// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yRFV","col":"styles_col__2Q96x"};